import { staffRequestAction } from "../../../_store";

export const handleReviewPrivateConvoNavigator = (
  direction = "next",
  list,
  indexValue,
  history,
  source,
  dispatch
) => {
  
  var row = {};
  if (list?.DataList?.length === indexValue) {
    //if in last last need to move first list (from nth to 0)
    row = list?.DataList[0];
    dispatch(staffRequestAction?.updateIndexValue(0));
  } else {
    row = list?.DataList[indexValue];
    dispatch(staffRequestAction?.updateIndexValue(indexValue));
  }

  history.navigate("StaffRequestList/PrivateConversationRequestForm", {
    state: {
      formID: row?.RequestFormTypeID,
      RequestFormType: row?.RequestFormType,
      InmateID: row?.InmateID,
      InmateResidentId: row?.InmateResidentId,
      formDetails: list,
      sourceFrom: "privateConversation",
    },
  });
};
